import React from 'react';
import { Box, Divider } from '@mui/material';
import ProductWaiversLog from '../ProductWaiversLog';
import WaiverSettings from '../WaiverSettings';
import WaiversLog from '../WaiversLog';
import {
  useRolePermissions,
  hasPermission,
  isSuperAdmin,
  isAdmin,
  isStudent,
  isParent
} from '@projectK/context/RolesProvider';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import StudentWaiversLog from '../../student/WaiversLog';
import ParentWaiversLog from '../../parent/WaiversLog';

const AllWaiverCombine = () => {
  const { rolePermissions } = useRolePermissions();
  const { user } = useAuthUser();
  const renderProductWaiversLog = () => {
    if (isSuperAdmin(user) || isAdmin(user)) {
      return <ProductWaiversLog />; 
    } else if (isStudent(user)) {
      return <StudentWaiversLog />; 
    } else if (isParent(user)) {
      return <ParentWaiversLog />;
    }
    return null;
  };


  return (
    <Box>
      {hasPermission(
        rolePermissions,
        'Company Settings - Waiver Settings',
        'read',
      ) && (
        <>
          <WaiverSettings />

          <Divider
            sx={{
              marginTop: 4,
              marginBottom: 5,
            }}
          />
        </>
      )}
      {hasPermission(
        rolePermissions,
        'Company Settings - Waiver Logs',
        'read',
      ) && (
        <>
          <WaiversLog />

          <Divider
            sx={{
              marginTop: 4,
              marginBottom: 5,
            }}
          />
        </>
      )}
    {hasPermission(rolePermissions, 'Product Waivers Log', 'read') && renderProductWaiversLog()}
    </Box>
  );
};

export default AllWaiverCombine;
